import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import styles from "./MarqueeText.module.css";

export function MarqueeText(props: {
  text: string;
  minLength?: number;
  style?: React.CSSProperties;
}) {
  const [shouldAnimate, setShouldAnimate] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (props?.minLength && props?.text.length >= props?.minLength) {
        setShouldAnimate(true);
      }
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      width={"100%"}
      height={"100%"}
      overflow={"hidden"}
      position={"relative"}
      justifyContent={
        props?.text?.length < (props?.minLength || 0) ? "center" : "flex-start" // style fix for center aligning short text
      }
    >
      <Box
        display={"block"}
        position={"absolute"}
        overflow={"hidden"}
        className={shouldAnimate ? styles.marquee__anim : ""}
      >
        <Typography noWrap sx={{ ...props?.style }}>
          <span>{props?.text}</span>
          {shouldAnimate ? (
            <span style={{ marginLeft: "64px" }}>{props.text}</span>
          ) : null}
        </Typography>
      </Box>
    </Stack>
  );
}
